export default __webpack_public_path__ + "static/checkIn-cfe09001333bdf5cde75cbc2d0911d36.jpg";